export default function PageSkeleton() {
  return (
    <div className="min-h-screen bg-slate-50 animate-pulse">
      {/* Nav skeleton */}
      <div className="h-16 bg-white border-b border-slate-100 flex items-center px-8 gap-6">
        <div className="h-8 w-32 bg-slate-200 rounded"></div>
        <div className="flex-1"></div>
        <div className="h-4 w-16 bg-slate-200 rounded hidden md:block"></div>
        <div className="h-4 w-16 bg-slate-200 rounded hidden md:block"></div>
        <div className="h-4 w-16 bg-slate-200 rounded hidden md:block"></div>
        <div className="h-8 w-24 bg-slate-200 rounded hidden md:block"></div>
      </div>
      {/* Hero skeleton */}
      <div className="h-[60vh] bg-slate-200"></div>
      {/* Content skeleton */}
      <div className="max-w-7xl mx-auto px-8 py-16 space-y-6">
        <div className="h-6 w-24 bg-slate-200 rounded mx-auto"></div>
        <div className="h-10 w-2/3 bg-slate-200 rounded mx-auto"></div>
        <div className="h-4 w-1/2 bg-slate-200 rounded mx-auto"></div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-64 bg-slate-200 rounded-xl"></div>
          ))}
        </div>
      </div>
    </div>
  );
}